import { render, staticRenderFns } from "./CommentsBlock.vue?vue&type=template&id=635be088&scoped=true"
import script from "./CommentsBlock.vue?vue&type=script&lang=js"
export * from "./CommentsBlock.vue?vue&type=script&lang=js"
import style0 from "./CommentsBlock.vue?vue&type=style&index=0&id=635be088&prod&scoped=true&lang=scss"
import style1 from "./CommentsBlock.vue?vue&type=style&index=1&id=635be088&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635be088",
  null
  
)

export default component.exports